import { render, staticRenderFns } from "./OpportunityIdentification.vue?vue&type=template&id=32c2f73c&scoped=true&"
import script from "./OpportunityIdentification.vue?vue&type=script&lang=js&"
export * from "./OpportunityIdentification.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityIdentification.vue?vue&type=style&index=0&id=32c2f73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2f73c",
  null
  
)

export default component.exports